<template>
    <div class="row justify-content-center">
        <div class="col-md-12">
            
            <div v-for="(files, category) in groupedFicheros" :key="category" class="mb-4">
                <h5 class="text-dark border-bottom pb-2 fw-bold text-capitalize mt-3">
                    <i class="fas fa-folder-open text-primary mr-2"></i> {{ category }}
                </h5>
                
                <table class="table table-bordered table-hover bg-white" v-if="files.length > 0">
                  <tbody>
                    <tr v-for="fichero in files" :key="fichero.uuid">
                        <td width="10%" class="text-center align-middle">
                            <h4>
                                <a v-bind:href="fichero.original_url" target="_blank" class="text-danger">
                                    <i v-if="fichero.extension==='pdf'" class="fa fa-file-pdf" aria-hidden="true"></i>
                                    <i v-else-if="['jpg','jpeg','png','gif'].includes(fichero.extension)" class="fa fa-file-image text-info" aria-hidden="true"></i>
                                    <i v-else class="fa fa-file text-secondary" aria-hidden="true"></i>
                                </a>
                            </h4>
                        </td>
                        <td width="80%" class="align-middle">
                            <a v-bind:href="fichero.original_url" target="_blank" class="text-dark font-weight-bold text-decoration-none"> 
                                {{ fichero.file_name }}
                            </a>
                        </td>
                        <td width="10%" class="text-center align-middle"> 
                            <button class="btn btn-sm btn-outline-danger" @click="borraFichero(fichero.uuid)">  
                                <i class="fa fa-trash" aria-hidden="true"></i>
                            </button>
                        </td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="text-muted small p-2 bg-light border rounded">
                    No se han subido archivos para la categoría <strong>{{ category }}</strong>.
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props: ["elecciones"],
    data() {
      return {
        id: "",
        ficheros: [],
        confirmacion:0,
      };
    },
    computed: {
        groupedFicheros() {
            const groups = {
                'preaviso': [],
                'constitucion': [],
                'resultados': [],
                'candidaturas': [],
                'sustituciones': [],
                'varios': []
            };

            this.ficheros.forEach(f => {
                let matched = false;
                for (let cat in groups) {
                    let catProp = f.custom_properties ? f.custom_properties.categoria : null;
                    if ((catProp && catProp === cat) || (!catProp && f.file_name && f.file_name.startsWith(cat + '_'))) {
                        groups[cat].push(f);
                        matched = true;
                        break;
                    }
                }
                if (!matched) {
                    groups['varios'].push(f);
                }
            });

            return groups;
        }
    },
    methods: {
      getListaFicheros: function () {
        axios.get("/elecciones/upload/listar_ficheros/" + this.id + "?t=" + new Date().getTime())
        .then(
          function (response) {
            this.ficheros = response.data.ficheros_elecciones;
          }.bind(this)
        );
      },
      borraFichero: function (uuid) {
        this.confirmacion=confirm('¿Estás seguro de eliminar permanentemente este archivo?');
        if (this.confirmacion) {
            axios.delete("/elecciones/borrar_fichero/" + this.id + "/" + uuid)
                .then(response => {
                    this.getListaFicheros();
                });
        }
      }
    },
    mounted() {
      this.id = this.elecciones.id;
      this.getListaFicheros();
    },
};
</script>
